import React from "react";
import PropTypes from "prop-types";

import "lazysizes";
import { Typography, Box, Grid, Checkbox, Link } from "@material-ui/core";
import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import { CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import get from "lodash/get";
import parse from "html-react-parser";

import PlayButton from "../PlayButton";

import {
  useCollectionState,
  useCollectionDispatch,
} from "../../context/CollectionContext";
import { staticUrl } from "../../clientAPI";
import { getThumbnailUrl } from "../../utils/common";

import {
  LazyLoadComponent,
} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import "react-lazy-load-image-component/src/effects/black-and-white.css";
// import { SimpleImg } from "react-simple-img";
// import LazyLoad from "react-lazy-load";

import "./lazyload.css";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      backgroundImage:
        "linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 50%)",
    },
    albumItem: {
      label: {
        color: "black",
      },
      margin: "5px",
      "&:first-child": {
        marginLeft: theme.spacing(0),
      },
      overflow: "hidden",
    },
    extraMarginBottom: {
      marginBottom: theme.spacing(2),
    },
    poster: {
      position: "relative",
      "&:hover $play": {
        opacity: 1,
      },
    },
    enlargePoster: {
      "&:hover $imgFluid": {
        [theme.breakpoints.up("xs")]: {
          transform: "scale(1.4)",
        },
        [theme.breakpoints.down("md")]: {
          transform: "none",
        },
      },
      "&:hover $play": {
        [theme.breakpoints.up("xs")]: {
          maxWidth: 195 * 1.4,
          maxHeight: 275 * 1.4,
        },
        [theme.breakpoints.down("md")]: {
          transform: "none",
        },
      },
    },
    imgFluid: {
      // width 100% & height auto keep image resize ratio
      width: "100%",
      maxWidth: 195,
      height: "auto",
      maxHeight: 275,
      transition: "opacity .3s, transform .2s !important",
      "&:before": {
        backgroundColor: "#dedede",
      },
    },
    placeholder: {
      width: 195,
      height: 275,
    },
    play: {
      display: "flex",
      position: "absolute",
      width: "100%",
      maxWidth: 195,
      height: "100%",
      maxHeight: 275,
      overflow: "auto",
      margin: "auto",
      top: 0,
      left: 0,
      alignItems: "center",
      justifyContent: "center",
      transitionDuration: "0.5s",
      opacity: 0,
      overflow: "hidden",
    },
    playButton: {
      overflow: "hidden",
      width: 120,
      height: 40,
      marginTop: theme.spacing(2),
    },
    playMask: {
      backgroundColor: "rgba(0, 0, 0, 0.65)",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    playMaskDetail: {
      padding: theme.spacing(2.5),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(3),
      color: "white",
    },
    maskMeta: {
      ...theme.typography.smallCaption,
      color: theme.palette.common.grey[300],
      marginTop: theme.spacing(0.5),
    },
    maskIntro: {
      ...theme.typography.smallCaption,
      marginTop: theme.spacing(0.5),
      [theme.breakpoints.down("sm")]: {
        marginTop: "1em",
        display: "none",
      },
    },
    info: {
      marginTop: 4,
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    title: {
      color: theme.palette.common.grey[900],
    },
    caption: {
      ...theme.typography.h7,
      color: theme.palette.common.grey[600],
      marginTop: theme.spacing(0.5),
    },
    relative: {
      position: "relative",
    },
    blockWithText: {
      maxWidth: "10rem",
      overflow: "hidden",
      position: "relative",
      lineHeight: "1.67em",
      maxHeight: `${1.67 * 5}em`,
      textAlign: "justify",
    },
    checkbox: {
      maxWidth: 195,
      maxHeight: 275,
    },
    checkboxItem: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      borderRadius: 0,
      padding: 0,
      // higher than lazyload img and white mask
      zIndex: 10,
    },
    triangle: {
      position: "absolute",
      top: 0,
      right: 0,
      borderStyle: "solid",
      borderWidth: "0 80px 80px 0",
      borderColor: "transparent",
      borderRightColor: theme.palette.primary.main,
    },
    whiteMask: {
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.6)",
      // higher than lazyload img but less than white mask
      zIndex: 9,
    },
    whiteMaskSelected: {
      borderRadius: 5,
      border: "solid 3px black",
    },
    link: {
      cursor: "pointer",
    },
  }),
);

const Triangle = () => {
  const classes = useStyles();
  return <div className={classes.triangle}></div>;
};

const RectangleMask = ({ checked }) => {
  const classes = useStyles();
  return (
    <div
      className={classNames(classes.whiteMask, {
        [classes.whiteMaskSelected]: checked,
      })}
    ></div>
  );
};

const BlackCheckbox = withStyles({
  root: {
    color: "black",
    "&$checked": {
      color: "black",
    },
  },
})(props => (
  <>
    <RectangleMask checked={props.checked} />
    <Checkbox color='default' icon={<CheckBoxOutlineBlankIcon />} {...props} />
  </>
));

const ImgPlaceholder = () => {
  // const classes = useStyles();
  // return <Skeleton classes={{ root: classes.placeholder }} variant='rect' />;
  // return <div className={classes.imgFluid}></div>;
  return <div style={{ backgroundColor: "#dedede" }}></div>;
};

// function addDefaultSrc (ev) {
//   ev.target.src = `${staticUrl}/poster/default_poster.png`;
// }

const MovieAlbumItem = ({
  item,
  showMeta,
  showTitle,
  showHover,
  showCheckBox,
  editing,
  hoverMaskMode,
  hoverEnlargePoster,
  extraMarginBottom,
  customMetaText,
  collectionID,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { videoSelected } = useCollectionState();
  const collectionDispatch = useCollectionDispatch();
  const { id, description } = item;
  const selected = get(videoSelected, collectionID, []);

  const handleChange = event => {
    if (selected.indexOf(id) === -1) {
      collectionDispatch({
        type: "SELECT_COLLECTION_VIDEO",
        payload: { cid: collectionID, vid: id },
      });
    } else {
      collectionDispatch({
        type: "UNSELECT_COLLECTION_VIDEO",
        payload: { cid: collectionID, vid: id },
      });
    }
  };

  const HoverMask = ({ display }) => {
    if (hoverMaskMode === "simple") {
      return (
        <Box
          className={classNames(classes.play, classes.playMask)}
          display={display}
        >
          <PlayButton vid={id} />
        </Box>
      );
    }

    return (
      <div
        className={classNames(
          classes.play,
          classes.playMask,
          classes.playMaskDetail,
        )}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.maskTitle} variant='h5'>
              {item.name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.maskMeta}>{item.others}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Box
              className={classNames(classes.maskIntro, classes.blockWithText)}
            >
              {parse(description.replace(/^<p>/, "").replace(/<\/p>$/, ""))}
            </Box>
          </Grid>

          <Grid container item justify='center'>
            <Grid item>
              <Box className={classes.playButton}>
                <PlayButton vid={id} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <Link
      className={classes.link}
      underline='none'
      onClick={e => {
        if (editing) {
          handleChange(e);
        } else {
          history.push(`/video/detail/trailer/${id}`);
        }
      }}
    >
      <div
        className={classNames(classes.albumItem, {
          [classes.extraMarginBottom]: extraMarginBottom,
        })}
      >
        <div
          className={classNames(classes.poster, {
            [classes.enlargePoster]: hoverEnlargePoster,
          })}
        >
          <div
            className={classNames(classes.checkbox, {
              [classes.relative]: !hoverEnlargePoster,
            })}
          >
            {showCheckBox && editing && (
              <>
                <BlackCheckbox
                  className={classes.checkboxItem}
                  checked={selected.indexOf(id) !== -1}
                  disabled={!editing}
                />
              </>
            )}
            {/* <LazyLoadImage
              className={classes.imgFluid}
              alt={item.name}
              src={`${staticUrl}${item.poster}`}
              effect='blur'
              placeholder={<ImgPlaceholder />}
            /> */}
            <LazyLoadComponent
              className={"lazy-load-image-background"}
              placeholder={<ImgPlaceholder />}
            >
              <picture className={"lazy-load-image-background"}>
                <source
                  className={classes.imgFluid}
                  type='image/webp'
                  srcSet={getThumbnailUrl({ url: item.poster, ext: "webp" })}
                />
                <source
                  className={classes.imgFluid}
                  type='image/jpg'
                  srcSet={getThumbnailUrl({ url: item.poster, ext: "jpg" })}
                  alt={item.name}
                />
                <img
                  className={classes.imgFluid}
                  src={getThumbnailUrl({ url: item.poster })}
                  alt={item.name}
                />
              </picture>
            </LazyLoadComponent>

            {/* {
              <SimpleImg
                className={classes.imgFluid}
                src={`${staticUrl}${item.poster}`}
                placeholder='#dedede'
              />
            } */}
            {/* <div className={classes.imgFluid}>
              <img
                className={classNames("lazyload", classes.imgFluid)}
                data-sizes='auto'
                data-src={`${staticUrl}${item.poster}`}
                class='lazyload'
              />
              <img
                className={classNames(classes.imgFluid)}
                src={`${staticUrl}${item.poster}`}
              />
            </div> */}
            {showHover && <HoverMask />}
          </div>
          <div className={classes.info}>
            <Typography variant='h4' className={classes.title}>
              <Box display={showTitle ? "block" : "none"}>{item.name}</Box>
            </Typography>
            <div className={classes.caption}>
              <Box display={showMeta ? "block" : "none"}>{item.others}</Box>
              <Box display={customMetaText ? "block" : "none"}>
                {customMetaText}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

MovieAlbumItem.defaultProps = {
  showMeta: true,
  showTitle: true,
  showHover: true,
  showCheckBox: true,
  editing: false,
};

MovieAlbumItem.propsTypes = {
  showMeta: PropTypes.bool,
  showTitle: PropTypes.bool,
  showHover: PropTypes.bool,
  showCheckBox: PropTypes.bool,
  editing: PropTypes.bool,
  customMetaText: PropTypes.string,
};

export default MovieAlbumItem;
